module.exports = __webpack_public_path__ + "assets/img/mask-bg1.ed63a605.png";